export default __webpack_public_path__ + "static/media/token_infos.2999ee76.svg";